import React from 'react';

import { ReactComponent as ClockProcess } from '../../../assets/icons/ClockProcess.svg';
import utils from '../../../services/utils';

import classes from './HeadPay.module.scss';

const HeadPay = ({ totalToPay, text }) => {
  return (
    <div className={classes.header}>
      <ClockProcess className={classes.icon} />
      <span className='semibold-20'>¡Listo! Tu pago está en proceso.</span>
      <span className='bold-20'>Total a pagar {utils.moneyFormat(totalToPay)}</span>
      <span className={`${classes['color-blue-night-2']} medium-16`}>{text}</span>
    </div>
  );
};

export default HeadPay;
